import { gql } from "@apollo/client";

export const GET_ESTADOS_CREDITICIA = gql`
query allEstadoCrediticio{
    allEstadoCrediticio {
        idEstadoCrediticio,
        descripcion
    }
  }
`;

export const adaptEstadoCrediticio = (estado) => ({
  id: estado.idEstadoCrediticio,
  displayName: estado.descripcion
});

export const adaptEstadoCrediticioArray = (estados) =>
structuredClone(estados?.allEstadoCrediticio)?.
map((estado) => adaptEstadoCrediticio(estado));